"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparisonIgnoringUndefined = void 0;
const lodash_1 = __importDefault(require("lodash"));
// See https://stackoverflow.com/a/57894104
const comparisonIgnoringUndefined = (a, b) => {
    if (lodash_1.default.isArray(a) || lodash_1.default.isArray(b))
        return;
    if (!lodash_1.default.isObject(a) || !lodash_1.default.isObject(b))
        return;
    // @ts-ignore
    if (!lodash_1.default.includes(a, undefined) && !lodash_1.default.includes(b, undefined))
        return;
    // Call recursively, after filtering all undefined properties
    return lodash_1.default.isEqualWith(lodash_1.default.omitBy(a, (value) => value === undefined), lodash_1.default.omitBy(b, (value) => value === undefined), exports.comparisonIgnoringUndefined);
};
exports.comparisonIgnoringUndefined = comparisonIgnoringUndefined;
//# sourceMappingURL=comparisonIgnoringUndefined.js.map